import {
  useGetAdminCurrentQuery,
  useLogoutMutation
} from '@bo-services/authenticationApi';
import Cookies from 'js-cookie';
import { UserDetails } from '@bo-components/navigation/UserDetails';
import { useNavigate } from 'react-router-dom';

export const NavUser = () => {
  const { data: endpointData } = useGetAdminCurrentQuery();

  const navigate = useNavigate();
  const [logout, { isLoading }] = useLogoutMutation();

  const handleLogoutClick = async () => {
    try {
      await logout().unwrap();
      window.google.accounts.id.disableAutoSelect();
    } catch {
      Cookies.remove('_prizepicks_session');
    }
    navigate('/');
  };

  if (!endpointData) {
    return null;
  }
  const { data } = endpointData;
  const { attributes } = data;
  const {
    first_name: firstName,
    google_avatar: googleAvatar,
    last_name: lastName
  } = attributes;

  return (
    <UserDetails
      disabled={isLoading}
      firstName={firstName ?? undefined}
      lastName={lastName ?? undefined}
      googleAvatarUrl={googleAvatar ?? undefined}
      handleOnLogoutClick={handleLogoutClick}
    />
  );
};
